// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-text-container table {
  width: 100%;
  border-collapse: collapse;
}

.markdown-text-container th,
.markdown-text-container td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
}

.markdown-text-container h2,
h3 {
  color: #3cc8a1;
  font-size: 16px;
  font-weight: 800;
}

.markdown-text-container li {
  list-style: disc;
  margin-left: 20px;
}
.markdown-text-container h1 {
 
  margin-top: 8px;
  font-size: 20px;
  font-weight: 700;
  color: #3F3F46;

}
@media (min-width: 1024px) {
  .markdown-text-container h1 {
    font-size: 30px;
  }
}

.markdown-text-container table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.markdown-text-container th,
.markdown-text-container td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
}

.markdown-text-container h2 {
  color: #3cc8a1;
  font-size: 20px;
  font-weight: 800;
  margin-top: 20px;
}

.markdown-text-container h3 {
  color: #3cc8a1;
  font-size: 16px;
  font-weight: 800;
  margin-top: 15px;
}

.markdown-text-container ul {
  list-style-type: disc;
  margin-left: 20px;
}

.markdown-text-container li {
  margin-bottom: 10px;
}

.markdown-text-container .note {
  font-style: italic;
  color: #555;
  margin-top: 10px;
}
.markdown-text-container {
  font-weight: 300;
}
`, "",{"version":3,"sources":["webpack://./src/components/markdown-render/articleStyles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;;AAEhB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".markdown-text-container table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.markdown-text-container th,\n.markdown-text-container td {\n  border: 1px solid black;\n  padding: 8px;\n  text-align: left;\n}\n\n.markdown-text-container h2,\nh3 {\n  color: #3cc8a1;\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.markdown-text-container li {\n  list-style: disc;\n  margin-left: 20px;\n}\n.markdown-text-container h1 {\n \n  margin-top: 8px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #3F3F46;\n\n}\n@media (min-width: 1024px) {\n  .markdown-text-container h1 {\n    font-size: 30px;\n  }\n}\n\n.markdown-text-container table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.markdown-text-container th,\n.markdown-text-container td {\n  border: 1px solid black;\n  padding: 8px;\n  text-align: left;\n}\n\n.markdown-text-container h2 {\n  color: #3cc8a1;\n  font-size: 20px;\n  font-weight: 800;\n  margin-top: 20px;\n}\n\n.markdown-text-container h3 {\n  color: #3cc8a1;\n  font-size: 16px;\n  font-weight: 800;\n  margin-top: 15px;\n}\n\n.markdown-text-container ul {\n  list-style-type: disc;\n  margin-left: 20px;\n}\n\n.markdown-text-container li {\n  margin-bottom: 10px;\n}\n\n.markdown-text-container .note {\n  font-style: italic;\n  color: #555;\n  margin-top: 10px;\n}\n.markdown-text-container {\n  font-weight: 300;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
